import {
  ContentChild,
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  inject,
  DOCUMENT,
} from '@angular/core';

@Directive({
  selector: '[appLazyLoad]',
  standalone: true,
})
export class LazyLoadDirective {
  private document = inject(DOCUMENT);
  @ContentChild('detector') detector: ElementRef;

  @Input() end: boolean;
  @Input() loading: boolean;
  @Output() loadingChange = new EventEmitter<boolean>();
  @Output() load = new EventEmitter();

  @HostListener('window:scroll')
  onScroll(): void {
    if (!this.end && !this.loading && this.isInViewport(this.detector.nativeElement)) {
      this.load.next(true);
    }
  }

  private isInViewport(elm: HTMLElement): boolean {
    var elementTop = elm.offsetTop;
    var elementBottom = elementTop + elm.offsetHeight;

    // in this specific case the scroller is document.documentElement (<html></html> node)
    var viewportTop = this.document.documentElement.scrollTop;
    var viewportBottom = viewportTop + this.document.documentElement.clientHeight;

    const inViewPort = elementBottom > viewportTop && elementTop < viewportBottom;
    this.loading = inViewPort;
    this.loadingChange.next(this.loading);
    return inViewPort;
  }
}
